function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'purple': 'rgb(92, 55, 162)','gray': 'rgb(162, 170, 173)','pink': 'rgb(255, 105, 175)','red': 'rgb(166, 25, 46)','natural': 'rgb(222, 209, 182)','cream': 'rgb(228, 213, 196)','blue': 'rgb(0, 103, 185)','dark-blue': 'rgb(0, 0, 139)','light-blue': 'rgb(48, 127, 226)','maroon': 'rgb(134, 38, 51)','teal': 'rgb(0, 186, 179)','navy': 'rgb(4, 30, 66)','orange': 'rgb(237, 139, 0)','ivory': 'rgb(248, 242, 233)','yellow': 'rgb(255, 209, 0)','green': 'rgb(0, 64, 53)','natural': 'rgb(230, 216, 194)','sand': 'rgb(215, 207, 192)',};

    this.images = {'style-1': 'url("//shop.thepwhl.com/cdn/shop/files/PomPomStyle_1_68x.png?v=8979928674867380924")','style-2': 'url("//shop.thepwhl.com/cdn/shop/files/PomPomStyle_2_68x.png?v=10638948362844463262")','style-3': 'url("//shop.thepwhl.com/cdn/shop/files/PomPomStyle_3_68x.png?v=16168229526300955680")','style-4': 'url("//shop.thepwhl.com/cdn/shop/files/PomPomStyle_4_68x.png?v=4302368902724400219")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
